import React from "react";
// import '../Menu2.css'; // Updated CSS file
import Footer from "./footer";
import Homecarousel from "./homecarousel";
import Navbar from "./navbar";

const StandardsCoverage = () => {
	return (
		<>
			<Navbar />
			<div>
				<Homecarousel />
			</div>

			<div
				style={{ padding: "20px 15px", maxWidth: "1330px", margin: "0 auto" }}>
				<div className="content-container" style={{ marginBottom: "6rem" }}>
					<div style={{ marginBottom: "0rem", marginTop: "40px" }}></div>
					<div
						className="text-container-2"
						style={{
							width: "100%",
							borderRadius: "0px",
							paddingBottom: "10px",
						}}>
						<p
							style={{
								textAlign: "center",
								marginBottom: "0px",
							}}>
							<b
								style={{
									fontFamily: "Rajdhani, sans-serif",
									fontSize: "24px",
									fontWeight: 700,
									height: "auto",
									letterSpacing: "0.5px",
									lineHeight: "36px",
									textAlign: "center",
								}}>
								Farm to Fork:
							</b>
						</p>
						<p
							style={{
								fontFamily: "Rajdhani, sans-serif",
								fontSize: "24px",
								fontWeight: 500,
								letterSpacing: "0.5px",
								lineHeight: "36px",
								textAlign: "center",
							}}>
							Comprehensive coverage of global standards for every step of the
							agri-food value chain.
						</p>{" "}
						<p
							style={{
								textAlign: "center",
								marginTop: "30px",
							}}>
							<b
								style={{
									fontFamily: "Rajdhani, sans-serif",
									fontSize: "24px",
									fontWeight: 700,
									height: "auto",
									letterSpacing: "0.5px",
									lineHeight: "36px",
								}}>
								On-Farm Production → Post-Harvest → Sustainability → Packaging →
								Export Compliance
							</b>
						</p>
					</div>
				</div>
			</div>
			<Footer />
		</>
	);
};

export default StandardsCoverage;
